module.exports = __webpack_public_path__ + "assets/img/reverse-sweep-2.c4d8b833.jpg";